import {HICAPS} from 'base/search.js';
import events from 'directory/widget/events.js';
import ko from 'knockout';
import NameSearchManager from 'directory/widget/name_search_manager.js';
import query from 'directory/widget/query.js';

import 'directory/widget/stop_binding.js';
import 'directory/widget/autocomplete.js';

const HCF_ID = '1';
class SpecialtyManager {
    constructor() {
        this.specialty = ko.observable();
        this.locality = ko.observable();
        this.shouldShowDisclaimer = ko.computed(() => {
            const disclaimer = document.getElementById(
                'disclaimer_notification',
            );

            if (disclaimer.dataset.healthFundId === HCF_ID) {
                document.getElementsByClassName(
                    'hs-powered',
                )[0].style.margin = 0;
                return true;
            }
            return false;
        });
        this.specialtyPlaceholder = ko.computed(() => {
            const disclaimer = document.getElementById(
                'disclaimer_notification',
            );
            if (disclaimer.dataset.healthFundId === HCF_ID) {
                return "eg. 'Dentist'";
            }
            return "eg. 'Cardiologist'";
        });
    }
}
function manageTabs() {
    const tabContainer = document.getElementById('tabs');
    const sectionColour = document.body.dataset.sectionColour;
    if (tabContainer) {
        const tabListItems = Array.from(
            tabContainer.getElementsByTagName('li'),
        );
        const tabButtons = Array.from(tabContainer.getElementsByTagName('a'));

        const tabShown = document.createEvent('Event');
        tabShown.initEvent('tabShown', true, true);

        for (const button of tabButtons) {
            events.listen(button, 'mouseenter', function () {
                if (!button.classList.contains('active')) {
                    button.parentNode.getElementsByTagName(
                        'a',
                    )[0].style.color = sectionColour;
                }
            });
            events.listen(button, 'mouseleave', function () {
                if (!button.classList.contains('active')) {
                    button.parentNode.getElementsByTagName(
                        'a',
                    )[0].style.color = '';
                }
            });

            events.listen(button, 'click', function (event) {
                event.preventDefault();
                for (const item of tabListItems) {
                    item.classList.remove('active');

                    const aTag = item.getElementsByTagName('a')[0];
                    const targetId = aTag.getAttribute('href').substr(1);
                    const target = document.getElementById(targetId);
                    target.classList.remove('active');
                    aTag.style.borderBottomColor = '';
                    aTag.style.color = '';
                    target.style.display = 'none';
                }
                button.parentNode.classList.add('active');
                button.parentNode.getElementsByTagName(
                    'a',
                )[0].style.borderBottomColor = sectionColour;
                button.parentNode.getElementsByTagName(
                    'a',
                )[0].style.color = sectionColour;

                const targetId = button.getAttribute('href').substr(1);
                const target = document.getElementById(targetId);
                target.classList.add('active');
                document.getElementById(targetId).style.display = '';
                button.dispatchEvent(tabShown);
            });
        }

        if (location.hash) {
            const hash = location.hash;
            for (const item of tabListItems) {
                item.classList.remove('active');
            }
            const current = tabContainer.querySelectorAll(
                `[href="${hash}"]`,
            )[0];
            current.click();
        }
    }
}

events.ready().then(function () {
    manageTabs();
    const items = document.querySelectorAll('a[data-toggle="tab"]');
    for (const item of items) {
        events.listen(item, 'tabShown', function () {
            localStorage.lastTab = item.getAttribute('href');
            const elem = document.querySelector(item.getAttribute('href'));
            elem.querySelector('input[type="text"]').focus();
        });
    }
    const tabs = document.querySelectorAll('#tabs a');
    for (const tab of tabs) {
        events.listen(tab, 'click', function () {
            for (const tab of tabs) {
                tab.classList.remove('active');
            }
            tab.classList.add('active');
        });
    }
    const form = document.getElementById('search-form');
    events.listen(form, 'submit', function (evt) {
        for (const input of Array.from(form.getElementsByTagName('input'))) {
            if (!input.value) {
                evt.preventDefault();
                return false;
            }
        }
        return true;
    });

    const specialtyManager = new SpecialtyManager();
    ko.applyBindings(specialtyManager, document.getElementById('specialty'));
    const hiddenSpecialty = document.getElementById('specialty-id');
    if (hiddenSpecialty && hiddenSpecialty.value) {
        specialtyManager.specialty(hiddenSpecialty.value);
    }
    const elem = document.getElementById('name');
    const {filter, health_fund} = query.parse();
    const nameSearchArgs = {health_fund};
    if (filter === HICAPS) {
        nameSearchArgs.filter = filter;
    }
    if (hiddenSpecialty && hiddenSpecialty.value) {
        nameSearchArgs.specialty = hiddenSpecialty.value;
    }
    const manager = new NameSearchManager(nameSearchArgs, elem);
    ko.applyBindings(manager, elem);
});
